/* ============================================
   EMAIL SIGNUP → Klaviyo (client-side subscribe)
   Wires every form marked with [data-klaviyo-signup].
   Each form needs: an input[type=email], a button[type=submit],
   and an element with [data-signup-msg]. Optional data-source label.
   ============================================ */
(function () {
  'use strict';

  /* ── CONFIG — Klaviyo ──
     PUBLIC_KEY: public API key / Site ID (safe in browser)
     LIST_ID:    list to subscribe people to                 */
  var PUBLIC_KEY = 'Wxx5Sn';
  var LIST_ID = 'WdBixa';

  function validEmail(v) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
  }

  function wire(form) {
    /* A form may target a different Klaviyo list than the default — the popup
       subscribes to the list its welcome/discount flow listens on, which is not
       necessarily the footer's list. */
    var listId = form.getAttribute('data-klaviyo-list') || LIST_ID;
    var emailInput = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-signup-msg]');
    var consentInput = form.querySelector('input[type="checkbox"]');

    function setMsg(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('is-error', ok === false);
      msg.classList.toggle('is-ok', ok === true);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = (emailInput && emailInput.value || '').trim();
      if (!validEmail(email)) { setMsg('Please enter a valid email address.', false); return; }
      if (consentInput && !consentInput.checked) { setMsg('Please tick the box to sign up.', false); return; }
      if (!PUBLIC_KEY || !listId) { setMsg('Signup isn’t configured yet.', false); return; }

      if (btn) btn.disabled = true;
      setMsg('Signing you up…', true);

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(PUBLIC_KEY), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('data-source') || 'Website signup',
              profile: {
                data: { type: 'profile', attributes: { email: email } }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      })
        .then(function (res) {
          if (res.ok || res.status === 202) {
            form.reset();
            setMsg('Thanks — check your inbox to confirm.', true);
            /* Fires only on a genuine 2xx. The popup advances to its code step
               on this — NOT on the `is-ok` class, which setMsg also puts on the
               interim "Signing you up…" line and so fires before Klaviyo has
               answered. */
            form.dispatchEvent(new CustomEvent('brume:signup-success', { bubbles: true }));
          } else {
            setMsg('Something went wrong. Please try again.', false);
          }
        })
        .catch(function () { setMsg('Something went wrong. Please try again.', false); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  var forms = document.querySelectorAll('[data-klaviyo-signup]');
  for (var i = 0; i < forms.length; i++) wire(forms[i]);
})();
